import React, { useEffect, useState } from 'react';
import MainOnboard from '../mainOnboard';
import rovquest_logo from 'assets/images/rovquest_logo_primary.png';
import forgot_password from 'assets/icons/forgot_password.svg';
import back from 'assets/icons/back.svg';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE_URL } from 'config/constant';
import { languageHeaders } from 'config/requestLanguage';
import { useTranslation } from 'react-i18next';
import { useRequiredFields } from 'reusable/useRequiredFields';

const ForgotPassword: React.FC = (w) => {
  const { t } = useTranslation('login');
  const [email, setEmail] = useState('');
  const [errorEmail, setErrorEmail] = useState(false);
  const navigate = useNavigate();
  // EV-436。必須の欄は required ではなく aria-required で伝え、空のまま送ったときだけここで止める。
  const required = useRequiredFields({ email: 'email' });

  useEffect(() => {
    setErrorEmail(false);
  }, [email]);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event?.preventDefault();
    if (!required.check({ email })) return;

    try {
      const response = await axios.post(
        `${API_BASE_URL}/v1/request_reset_password/`,
        { email: email },
        // EV-271。表示言語を送り、エラー文の言語をそろえる。
        { headers: languageHeaders() }
      );
      navigate('/reset-password', { state: { email } });
    } catch (error) {
      setErrorEmail(true);
    }
  };

  return (
    <div className="flex min-h-screen">
      <img
        src={rovquest_logo}
        alt="RovQuest Logo"
        className="fixed top-8 left-6 w-64 h-16"
      />
      <div className="flex-1 flex items-center">
        <div className="flex-col justify-start items-center gap-12 inline-flex w-full mx-20">
          <div className="flex-col justify-start items-center gap-6 inline-flex">
            <img src={forgot_password} alt="" />
            <div className="w-full flex-col justify-start items-center gap-2 inline-flex">
              <div className="text-black text-[33px] font-bold font-['Noto Sans'] leading-10">
                {t('forget-password.title')}
              </div>
              <div className="flex flex-col self-stretch text-center text-neutral/100 text-subtitle-1 font-medium">
                <p>{t('forget-password.sub-title1')}</p>
                <p>{t('forget-password.sub-title2')}</p>
              </div>
            </div>
          </div>
          <form
            onSubmit={handleSubmit}
            className="w-full flex-col justify-start items-center gap-12 inline-flex"
          >
            <div className="flex-col justify-start items-start gap-1 w-full">
              <label
                htmlFor="email"
                className="block mb-2 text-sm font-regular text-neutral/100"
              >
                {t('forget-password.email')}
              </label>
              <input
                type="email"
                id="email"
                className="w-full border border-neutral/50 text-neutral/30 focus:outline-none focus:border-neutral/75 text-body-2 rounded-md h-12 pl-4 pr-12"
                placeholder={t('forget-password.email-holder')}
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  required.clear('email');
                }}
                {...required.fieldProps('email')}
              />
              {required.message('email')}
              {errorEmail && (
                <div className="bg-error/[0.1] text-error px-4 py-3 rounded-lg relative mt-2">
                  <span className="block sm:inline">
                    {t('forget-password.error_email')}
                  </span>
                </div>
              )}
            </div>
            <div className="flex flex-col w-full">
              <button
                type="submit"
                className="flex w-full h-16 rounded-lg justify-center items-center bg-primary/300 text-title text-white"
              >
                {t('forget-password.button')}
              </button>
            </div>
          </form>
          <a className="flex items-center gap-2" href="/login">
            <img src={back} alt="" />
            <div className="text-subtitle-1 text-neutral/300">
              {t('forget-password.back')}
            </div>
          </a>
        </div>
      </div>
      <MainOnboard variant="safety" />
    </div>
  );
};

export default ForgotPassword;
